export { DefaultMinimap } from "../maps/DefaultMinimap"

/** Stub behavior for import entries */
export const enum Stub {
  noop,
  zero,
  enoent,
  ebadf,
  ebadf_neg,
  resize_heap,
  abort,
  cxa_throw,
  throw_longjmp,
  exit,
  date_now,
  environ_sizes_get,
  assert_fail,
  getcwd,
}

/**
 * Configuration mapping minified WASM export/import names for an Emscripten-compiled module.
 * Consumers build this from their module-specific export enum (e.g. PdfiumExports).
 */
export type WasmExportConfig = {
  /** Minified import module name (e.g. "a") */
  readonly import_module: string
  /** Minified export name for WebAssembly.Memory */
  readonly memory: string
  /** Minified export name for __indirect_function_table */
  readonly indirect_func_table?: string
  /** Minified export name for __wasm_call_ctors */
  readonly wasm_call_ctors?: string
  /** Minified export name for setThrew */
  readonly set_threw?: string
  /** Minified export name for emscripten_stack_get_current */
  readonly stack_get_current?: string
  /** Minified export name for _emscripten_stack_restore */
  readonly stack_restore?: string
  /** Invoke wrappers: key=minified invoke import name, value=minified dynCall export name */
  readonly invokes?: Readonly<Record<string, string>>
  /** Syscall/fd/env stubs: key=minified name, value=stub behavior */
  readonly stubs?: Readonly<Record<string, Stub>>
  /** Minified module name for WASI imports */
  readonly wasi_module?: string
  /** WASI stubs */
  readonly wasi_stubs?: Readonly<Record<string, Stub>>
  /**
   * Build additional import functions that need access to the exports proxy.
   * Returns { env, wasi } records of minified-name -> import function.
   */
  readonly build_imports?: (exports: Record<string, unknown>) => Readonly<{
    readonly env: Readonly<
      Record<string, (...args: number[]) => number | bigint | undefined | void>
    >
    readonly wasi: Readonly<
      Record<string, (...args: number[]) => number | bigint | undefined | void>
    >
  }>
  /** Called after instantiation + __wasm_call_ctors, before returning instance */
  readonly init?: (exports: Record<string, unknown>) => void
  /** Set when loading a memory64 WASM module (pointers are BigInt, higher max heap) */
  readonly memory64?: boolean
  /** Maximum memory in bytes (default: 4GB for wasm32, 16GB for memory64) */
  readonly maximum_memory?: number
}
